module.exports = __webpack_public_path__ + "media/icons/re_black-8cd05dde.png";